import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-product-creation',
  templateUrl: './product-creation.component.html',
  styleUrls: ['./product-creation.component.css'],
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
  ]
})
export class ProductCreationComponent {

  constructor(private readonly user: UserService) { }

  public get hasConnectedAccount(): boolean {
    return this.user.connectedAccountId !== '' && this.user.isAdmin
  }

}
